import { ArrowLeftIcon, TrashIcon } from '@heroicons/react/24/outline';
import { CrewRoutes, withDomain } from '@theprintbar/shared';
import { Container, TransparentLinkButton } from '@theprintbar/ui';
import { useRootData } from '~/root';

export function QuoteBar({ quote }: { quote: string }) {
	const { crewDomain } = useRootData();
	return quote ? (
		<div className="relative bg-red text-white flex items-center h-8">
			<Container className="flex justify-between text-xs font-normal py-1 md:py-0">
				<TransparentLinkButton className="text-white" to={withDomain(CrewRoutes.Quotes.Landing, crewDomain)}>
					<ArrowLeftIcon className="h-4 w-4 mr-2" />
					Return to crew
				</TransparentLinkButton>
				<div className="items-center py-1 space-x-5 hidden md:flex">
					<h6 className="text-xs">Active Quote: #{quote}</h6>
				</div>
				<TransparentLinkButton to={withDomain(CrewRoutes.Quotes.DeleteActiveQuote, crewDomain)} className="text-white">
					<TrashIcon className="h-4 w-4 mr-2" />
					Delete
				</TransparentLinkButton>
			</Container>
		</div>
	) : null;
}
